<template>
  <m-card312 :image="product.thumbnail" :alt="product.name"
             :image-link="{name:'Product',params:{name:product.raw_link}}" class="product-card-912 p-3">


    <template #p-1>
      <m-a :href="{ name: 'Product', params: { name: product.raw_link } }">
        <p class="pt-3 product-card-body-312-title text-dark font-weight-bold text-right">{{ contentSlicer(product.name) }}</p>
      </m-a>
    </template>

    <template #p-2>
      <m-product-price100 class="text-center product-card-312-price" :product="product"/>
    </template>

    <template #p-3>
      <m-product-offer1 :offer-status="true" offer-type="percent"
                        class="product-card-312-offer "
                        :product="product"/>
    </template>

  </m-card312>
</template>

<script>
import {shoppingCartFunctions} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'
import mCard312 from "../../Cards/Card312";
import mA from '../../Tags/A'
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "ProductCard3",
  components: {mCard312, mA, mProductCardQuantityManager1, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    contentSlicer,
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>
.product-card-912-price :deep(*) {
  color: white;
}

.product-card-312-offer {
  z-index: 1000;
}

.product-card-312-offer :deep(.product-offer-1-background) {
  background: var(--danger);
  color: white;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-card-body-312-title {
  font-size: 14px;
}

.product-card-312-price :deep(*) {
  font-size: 14px ;
}

</style>